<template>
    <Spinner v-if="isLoading" />
    <div class="grid">        	    
        <div class="card col-12 mainTitle">
            <h3 class="stationsHeader">{{ translated('dashboard').toUpperCase() }}</h3>  
            <Button
                @click = "helpVisible=!helpVisible"
                icon = "pi pi-question"
                :label = "ponocString"
                class = "helpButton p-button-rounded">
            </Button>                   
        </div>		

        <div class="card col-12 helpSection" v-if="helpVisible">
            <h1>Osnovne informacije o aplikaciji</h1>
            <div class="sekcijaOpis">
                Aplikacija eLab namenjena je klijentima koji žele da iz udobnosti svog doma odaberu analize koje je potrebno obaviti. Kada dođu u laboratoriju, nije potrebno da razgovaraju ili objašnjavaju koje analize treba da obave - dovoljno je samo da pokažu QR kod. Skeniranjem koda automatski se preuzimaju sve unapred pripremljene analize. Uskoro će biti moguće i online plaćanje analiza. Pored analiza, aplikacija omogućava i naručivanje patronaže, gde možete odabrati željeni datum za dolazak naše službe na Vašu adresu. Potom, uz pomoć aplikacije i eLab centra, možete dogovoriti tačan termin.
            </div>

            <h3>Sekcija "MOJE POSETE"</h3>
            <div class="sekcijaOpis">Ova sekcija namenjena je kreiranju liste analiza koje želite da obavite, kao i pregledu svih analiza koje ste prethodno obavili u našoj ustanovi. Tu možete pratiti i status obrade analiza. Laboratorijski izveštaj će Vam biti dostupan kao PDF dokument sa rezultatima, koji ćete primiti i putem e-maila.</div>
            <ul>
                <li>Klikom na dugme "Sve posete", aplikacija vas vodi na pregled svih poseta koje ste do sada uneli u sistem i sve laboratorijske izveštaje</li>
                <li>Klikom na dugme sa simbolom "+" bićete preusmereni na opciju ‘Nova poseta’ gde možete izabrati analize koje su vam potrebne.</li>
            </ul>

            <h3>Sekcija "KUĆNE POSETE"</h3>
            <div class="sekcijaOpis">Sekcija "KUĆNE POSETE" namenjena je zakazivanju kućnih poseta, pregledu već obavljenih poseta, kao i pristupu dokumentima sa rezultatima analiza za te posete.</div>
            <ul>
                <li>Klikom na dugme "Sve kućne posete", aplikacija vas vodi na stranicu sa pregledom svih zakazanih kućnih poseta. Ovde možete naći informacije o starim završenim kućnim posetama, novim posetama koje još nisu realizovane, kao i onim posetama koje su trenutno u fazi dogovaranja. </li>
                <li>Klikom na dugme sa simbolom "+" preusmereni ste na obrazac gde možete uneti detalje o željenom terminu i osobi za koju je kućna poseta potrebna.</li>
            </ul>            
        </div>

        <div class="card col-12" v-if="messagesExists">              
            <div class="col-12" v-if="!isLoading">
                <!-- <h5 v-if="!messagesExists" class="p-col-12">NEMATE NEPROČITANE PORUKE</h5>  -->
                <h5 v-if="!messagesExists" class="p-col-12">{{ translated('noUnreadMessages').toUpperCase() }}</h5>
                <h5 v-else class="p-col-12">{{ translated('unreadmessages').toUpperCase() }}</h5>  
            </div> 
            <div v-if="messagesExists" class="grid nomessageimage">
                <div v-if="!messagesExists" class="col-12 bg-cover bg-center bg-no-repeat h-20rem w-full flex align-items-center justify-content-center" 
                :style="[ !messagesExists  ? { backgroundImage: `url(${imageNoMessage})` } : { backgroundImage: `transparent`}]" >

                </div>
                <div class="oanelunreadmessages col-12 md:col-6" v-if="dashboardList.unreadMessages!=undefined && dashboardList.unreadMessages.length>0" >   
                    <ul class="messageboxmain"> 
                        <li class="messagebox" v-for="x in dashboardList.unreadMessages" :key="x" >
                            <div v-if="x.messageRead">
                                {{x.message}}
                            </div>
                            <div v-else style="font-weight: bold;">
                                <router-link style="text-decoration: none; font-weight: bold; color:black" :to="{ name: 'HomeVisitReview', params: { id: x.homeVisitId}}">
                                    {{x.message}}
                                </router-link>
                            </div>
                            
                        </li>
                    </ul>
                </div>
                <div class="oanelunreadmessagespicture col-12 hidden md:col-6 md:block" v-if="dashboardList.unreadMessages!=undefined && dashboardList.unreadMessages.length>0" >   
                    <div class="grid analizabackground col-12 bg-cover bg-center bg-no-repeat h-20rem w-full flex align-items-center justify-content-center" 
                            :style="{ backgroundImage: `url(${imageporuka})` }">                                         
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12 md:col-6 wrapanaliza">
            <div class="analysis card">
                <!-- <h5 class="col-12">ANALIZE</h5>  -->
                <h5 class="col-12">{{ translated('mojeposete').toUpperCase() }}</h5> 
                <div class="analizekocka stats col-12 flex justify-content-center flex-wrap card-container">
                    <div class="grid analizabackground col-12 bg-cover bg-center bg-no-repeat h-20rem w-full flex align-items-center justify-content-center" 
                        :style="{ backgroundImage: `url(${imageanaliza})` }">                                         
                    </div>
                </div>                
                <div class="grid col-12 buttonplaceholder">
                    <div class="col-6 aktivneukupne font-bold text-2xl">
                        <!-- <Button label="Primary" class="p-button-rounded" @click="toAllAnalysisReview">{{dashboardList.activeAnalysis}}/{{dashboardList.allAnalysis}}</Button> -->
                        <Button :label="translated('sveposete')" class="p-button-rounded" @click="toAllAnalysisReview"></Button>
                    </div>
                
                    <div class="col-6 divButtonAdd">
                        <Button @click="toNewAnalysis()" :label="translated('newvisit')" class="p-button-rounded" />
                    </div>   
                </div>                
            </div>
        </div>

        

        <div class="col-12 md:col-6 wrappatronaza">
            <div class="homevisits card">
                <!-- <h5 class="col-12">PATRONAZE</h5>  -->
                <h5 class="col-12">{{ translated('homeVisits').toUpperCase() }} <div class="uskoroTitle">USKORO</div></h5> 
                <div class="patronazekocka stats col-12 flex justify-content-center flex-wrap card-container">
                    <div class="grid analizabackground col-12 bg-cover bg-center bg-no-repeat h-20rem w-full flex align-items-center justify-content-center" 
                        :style="{ backgroundImage: `url(${imagepatronaza})` }">
                        <div class="patronazanav col-12">
                            <div class="activeHomeVisits" style="padding:1%"> <!--TODO: NAPRAVITI KAO TABELU IMAS PRIMER U BUKMARKU opacity: 0.3; -->
                                <div class="lastHomeVisits card col-7 md:col-6" v-for="hv in dashboardList.homeVisitAbbreviated" :key="hv">
                                    <router-link :to="{ name: 'HomeVisitReview', params: { id: hv.id}}">
                                        {{ translated('person') }}: {{ hv.name }} {{ hv.surname }}  <br> {{ translated('requesteddate') }}: {{ formatDate(hv.requestedDate) }}  <br> Status: {{ translated("status_"+hv.status) }}
                                    </router-link>    
                                </div>
                            </div>
                        </div>                                         
                    </div>
                </div>
                <div class="grid col-12 buttonplaceholder">
                    <div class="col-6 aktivneukupne font-bold text-2xl">
                        <!-- <Button label="Primary" class="p-button-rounded" @click="toAllHomeVisitReview">{{dashboardList.allHomeVisits}}</Button>                         -->
                        <!-- <Button :label="translated('allHomeVisits')" class="p-button-rounded" @click="toAllHomeVisitReview"></Button> -->
                        <Button disabled :label="translated('allHomeVisits')" class="p-button-rounded" @click="toAllHomeVisitReview"></Button>
                    </div>
                    
                    <div class="col-6 divButtonAdd">
                        <Button disabled @click="toNewHomeVisit()" :label="translated('newhomevisit')" class="p-button-rounded" />

                    </div>

                </div>

            </div>
        </div>                    
    </div>
        
        <!-- <div>PROBA POJEDINACNOG PRIKAZA <br> 
        </div>  -->
    

</template>

<script>
import { computed } from "vue";
import createHttp from "@/services/http";
import store from "@/store";
import Spinner from "@/components/Spinner.vue"
import imageAnaliza from "@/assets/analiza.jpg"
import imagePatronaza from "@/assets/homevisitNew.jpg"
import imagePoruka  from "@/assets/messages.jpg"
import imageNoMessage  from "@/assets/nomessage.jpg"

export default {
    components: { Spinner },   
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            publicPath: process.env.BASE_URL,
            dashboardList: {},
            translated: computed(() => store.getters.getTranslate),            
            isLoading: false,
            imageanaliza: imageAnaliza,
            imagepatronaza: imagePatronaza,
            imageporuka: imagePoruka,
            imageNoMessage: imageNoMessage,
            helpVisible: false
        }
    },  
    async mounted() {
        this.isLoading = true;
        // console.log(process.env.VUE_APP_API_FOLDER + "/GetDashboard");

        const http = createHttp(true); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetDashboard");
        
        // console.log('prejel created dashboard:')
        // console.log(result.data)
        
        if(result.status==200){
            this.dashboardList = result.data;
        }
        this.isLoading = false;
    },    
    computed: {
		messagesExists() {
            // console.log("Metoda: messagesExists");
            // console.log(this.dashboardList);
            
            if(typeof(this.dashboardList) === undefined)
                return false;

            if(typeof(this.dashboardList.unreadMessages) === undefined)
                return false;

            if(Array.isArray(this.dashboardList.unreadMessages) && !this.dashboardList.unreadMessages.length)
                return false;                

                // console.log('Vračam TRUE');
            return true;
        },
        ponocString() {
            return this.translated('translatedHelp');
        }
    },    
    methods: {        
        clickNew() {
            this.$router.push({ name: 'Companies', params: { approved: 0 } });
        },
        clickWithoutCode() {
            this.$router.push({ name: 'Companies', params: { approved: 2 } })
        },
        toAllAnalysisReview(){
            this.$router.push("allanalysisreview");
        },
        toAllHomeVisitReview(){
            this.$router.push("allhomevisitreview");
        },
        toNewAnalysis(){
            this.$router.push({ name: 'NewAnalysis', params: { id: '00000000-0000-0000-0000-000000000000', homevisitid: '00000000-0000-0000-0000-000000000000', source:'dashboard', linked: false } });
        },
        toNewHomeVisit(){
            //this.$router.push("newhomevisit");
            this.$router.push({ name: 'NewHomeVisit', params: { aid: '00000000-0000-0000-0000-000000000000' } });
        },
        formatDate(value) {
            if(value != null){
                let myDate = new Date(value);

                return myDate.toLocaleDateString('ro-Ro');
            }
        },
        async loadData() {
            let DashBoardUrl = process.env.VUE_APP_API_FOLDER + "/GetCompanyDashboardData";

            if(this.paramCompanyId)
                if(this.paramCompanyId!='00000000-0000-0000-0000-000000000000')
                    DashBoardUrl = DashBoardUrl + '?loadCompanyId=' + this.paramCompanyId

            //// console.log(DashBoardUrl);
            
            // klicem server da mi vrne stat. podatke o lokacijah
            const http = createHttp(true);
            const resultGC = await http.get(DashBoardUrl);
            //// console.log(resultGC);
            if (resultGC.status == 200) {
                this.Stats = resultGC.data;		
                

                // console.log(this.Stats)
            }   
            this.isLoading = false;
            //// console.log('konec metode loaddata');            
        }
    }      
}
</script>

<style scoped lang="scss">
@import "../App.scss";


.messageboxmain, .activeHomeVisits{
    list-style: none;
}


.wrapanaliza { padding-left: 0px;}
.wrappatronaza { padding-right: 0px;}

// .grid {margin-right: 0px !important;}
.analizekocka.stats.col-12 {padding-right: 0px; margin-right: 0px;}

.col-1.divButtonAdd button {position: relative;float: right;}
.col-1.divButtonAdd { padding-right: 0;}
.aktivneukupne { padding-left:15px}

.lastHomeVisits {
    box-shadow: 1px 1px 15px 1px #888888;
    opacity: 0.6;    
}

.lastHomeVisits a { text-decoration: none; color: black;}
.lastHomeVisits {
    min-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.grid.nomessageimage {
    padding-left: 7px;
    padding-right: 7px;
}

@media screen and (max-width: 768px) 
{ 
    .wrapanaliza { padding-right: 0px !important; }
    .wrappatronaza { padding-left: 0px !important; }
}

.uskoroTitle {
    position: relative;
    float: right;
    color: red;
    font-weight: bold;
    font-size: 25px;
}

.divButtonAdd button {position: relative;float: right;}
.buttonplaceholder {margin-left: 3px;}

</style>